module.exports = __webpack_public_path__ + "img/MD.ec66cc16.png";